import { FC } from "react";
import { QrTypes } from "../../../enums";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { QrStatusProps } from "../../../interfaces";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  container: {
    width: 89,
    height: 89,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  icon: {
    width: 27,
    height: 27,
    color: "#fff"
  }
});

const iconStyles = { color: "#fff", fontSize: "75px", fontWeight: 600 };

export const QrStatus: FC<QrStatusProps> = ({ type, iconClassName }) => {
  const classes = useStyles();
  return (
    <div className={`${classes.container} ${iconClassName}`}>
      {type === QrTypes.ERROR && <CloseIcon style={iconStyles} />}
      {type === QrTypes.SUCCESS && <CheckIcon style={iconStyles} />}
    </div>
  );
};
